export interface IVerifyToken {
  token: string;
  type: VerifyToneType;
}

export enum VerifyToneType {
  NEW_REGISTRATION = 'new_registration',
  RECOVERY_PASSWORD = 'recovery_password'
}
